import { Dialog, DialogContent, DialogTitle } from "@mui/material"
import CmPlayerEventsList from "./CmPlayerEventsList"

const CmPlayerEventsDialog = ({ open, onClose, playerEvent }) => (
    <Dialog
        sx={{
            "& .MuiDialog-paper": {
                minHeight: "300px",
                maxHeight: "80vh"
            }
        }}
        fullWidth
        maxWidth="md"
        open={open}
        onClose={onClose}
    >
        <DialogTitle>
            {playerEvent && (playerEvent?.table ?? playerEvent.eventId)}
        </DialogTitle>
        <DialogContent>
            {playerEvent && <CmPlayerEventsList playerEvent={playerEvent} />}
        </DialogContent>
    </Dialog>
)

export default CmPlayerEventsDialog
